import logo from './bookshelf_logo.svg'

const Logo = () => (
  <div className='return-policy-bookshelf-logo'>
    <img alt='' src={logo} />
  </div>
)

export default Logo
